module.exports = __webpack_public_path__ + "static/media/washington_int1.920e4fb4.jpg";